import * as React from "react";
import {Stack, Typography, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import {CompanyI18N} from "@/translations";
import {HakenIcon, XIcon} from "@/agentur/AgenturIcons";

/**
 * Legend for the read-only machinery park display.
 *
 * A disabled CheckboxInputField renders the check icon for a checked and the cross icon for an
 * unchecked entry instead of a checkbox; this legend names what the two icons stand for.
 *
 * @returns {React.ReactElement} The rendered MachineryParkLegend component.
 */
export const MachineryParkLegend: React.FC = (): React.ReactElement => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" sx={{ paddingTop: 1 }}>
            <Typography variant="caption" color="text.secondary">
                {t(CompanyI18N.form.legend.title)}
            </Typography>
            <Stack direction="row" spacing={0.5} alignItems="center">
                <HakenIcon mode={theme.palette.mode} />
                <Typography variant="caption" color="text.secondary">
                    {t(CompanyI18N.form.legend.machineryParkAvailable)}
                </Typography>
            </Stack>
            <Stack direction="row" spacing={0.5} alignItems="center">
                <XIcon mode={theme.palette.mode} />
                <Typography variant="caption" color="text.secondary">
                    {t(CompanyI18N.form.legend.machineryParkNotAvailable)}
                </Typography>
            </Stack>
        </Stack>
    );
};
